<div class="step_container" [formGroup]="form">
    <div class="steps_block">
      <div class="step no_step">
        <div class="step_title inline_title">
          <span>
            {{"inventory.editing_product"|translate}}
          </span>
          <button (click)="closed()">
            <mat-icon style="color: black;">close</mat-icon>
          </button>
        </div>
        <div class="body_step">
          <div class="content image_content">
            <div class="field">
              <div class="drop_zone" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
                (drop)="onDrop($event)" (click)="fileInput.click()">
                <span>{{"inventory.drag_and_drop_the_images_here"|translate}}</span>
              </div>

              <input type="file" #fileInput (change)="onFileChange($event)" accept="image/jpeg, image/png, image/gif"
                style="display: none;" multiple>

              <!-- <div class="image_preview_container">
                <div *ngIf="uploadedImage" class="image-preview">
                  <img class="element_img" [src]="getImage()" alt="Uploaded image" />
                  <button class="cancel_upl" (click)="cancelImage()">
                    <mat-icon class="cancel_icon">cancel</mat-icon>
                  </button>
                </div>
              </div> -->

              <div class="clear-all-container">
                <button *ngIf="uploadedImages && uploadedImages.length > 0" class="clear-all-btn" (click)="removeAllImages()">
                  {{"inventory.clear_all_images"|translate}}
                </button>
              </div>
              <div class="image_preview_container">
                <div *ngFor="let image of uploadedImages" class="image-preview">
                  <img class="element_img" [src]="getImage(image)" alt="Uploaded image" />
                  <button class="cancel_upl" (click)="removeImage(image.id)">
                    <mat-icon class="cancel_icon">cancel</mat-icon>
                  </button>

                  <div class="bottom-section">
                    <button *ngIf="!image.isDefault" class="default-btn make-default-btn"
                            (click)="setDefault(image.id)">
                      {{"inventory.set_default_image"|translate}}
                    </button>
                    <div *ngIf="image.isDefault" class="default-banner">{{"inventory.default_image"|translate}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="content">
            <div class="field no_flex">
              <label for="">{{"common.name"|translate}}<span class="red">*</span></label>
              <input type="text" formControlName="name" [placeholder]="'common.name'|translate">
              <span class="error_ms" *ngIf="form.get('name')?.touched && form.get('name')?.errors">This field is required</span>
            </div>
            <div class="field no_flex">
              <label>{{"common.description"|translate}}</label>
              <ckeditor class="ck_editor" [editor]="Editor" data="" formControlName="description">
              </ckeditor>
            </div>
            <div class="inline_block">
              <div class="field equality_field">
                <label for="">{{"brands.brands"|translate}}</label>
                <input type="text" [placeholder]="'brands.brands'|translate" formControlName="brandControl" [matAutocomplete]="auto"
                  class="input">
                <mat-autocomplete #auto="matAutocomplete">
                  <ng-container *ngIf="filteredBrands$ | async as brands">
                    <mat-option *ngFor="let brand of brands" [value]="brand.name" (click)="onBrandSelected(brand)">
                      {{ brand.name }}
                    </mat-option>

                    <mat-option [value]="form.value.brandControl" class="add_option"
                      *ngIf="brands.length === 0 && form.value.brandControl"
                      (click)="addNewElement(form.value.brandControl, 'brand')">
                      <img src="assets/icones/add.svg" alt="">
                      {{"common.add"|translate}} "{{ form.value.brandControl }}"
                    </mat-option>
                  </ng-container>
                </mat-autocomplete>
              </div>
              <div class="field equality_field">
                <label for="">{{"common.status"|translate}}</label>
                <select name="" id="" formControlName="status">
                  <option selected value="" disabled>{{"common.status"|translate}}</option>
                  <option selected value="Published">{{"Categories.published"|translate}}</option>
                  <option selected value="Draft">{{"common.draft"|translate}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="steps_block">
      <div class="step">
        <div class="step_title">
          <span>
           {{"inventory.product_type"|translate}}
          </span>
        </div>
        <div class="cards">
          <div class="element_card">
            <div class="hearder_card" [class]="productType === 'standard' ? 'blue' : '' ">
              <mat-slide-toggle [checked]="productType === 'standard'" [disabled]="true">
              </mat-slide-toggle>
              <span>{{"inventory.standard_product"|translate}}</span>
            </div>
            <div class="content_card">
              <img src="assets/icones/hint.svg" alt="">
              <span>{{"inventory.standard_product_hind"|translate}}</span>
            </div>
          </div>
          <div class="element_card">
            <div class="hearder_card variant_header" [class]="productType === 'variante' ? 'blue' : '' ">
              <mat-slide-toggle [checked]="productType === 'variante'" [disabled]="true">
              </mat-slide-toggle>
              <span>{{"inventory.variant_product"|translate}}</span>
            </div>
            <div class="content_card">
              <img src="assets/icones/hint.svg" alt="">
              <span>
                {{"inventory.variant_product_hind"|translate}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="submet_btns">
      <button class="save_btn_pop_up cancel_btn_pop_up" (click)="closed()">
        <span>{{"common.back"|translate | uppercase}}</span>
        <img src="../../../../../assets/icones/arrow_back.svg" alt="">
      </button>
      <button class="save_btn_pop_up blue_btn" (click)="save()">
          <span>{{"common.save"|translate | uppercase}}</span>
          <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
      </button>
    </div>
  </div>
